export default "__VITE_ASSET__BKWVbyIK__"